module.exports = "/_next/static/images/Cover@2x-931739b8e1dd0e0ee9c7e45a96bcfc84.png";